<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="about-the-author">
<h1>About the Author</h1>
<p>Julie Earle was born in 1976 and raised in Luton, England. Her father told her fairy stories from his own imagination which captivated her into a fantasy world. As she grew up, she took her imaginative skills to school and got her first story published in the school magazine. After leaving school, Julie worked in a small playgroup filling children’s imagination with all her stories. She loved working with children and went on to receive a diploma in nursery nursing. She now lives in Essex with her husband and five children. Her passion for writing took over and she became a member of a freelance writing group. After having her fourth child, Julie began to create <em>The Magical Gate</em> series; and so it was born.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch001.vue?08ae5bec